import AQUA_LOGO from "../assets/img/aqua_logo_v2.png";
import LogoRound from "../assets/img/aqua/logo-round.png";
import Shrimp from "../assets/img/aqua/shrimp.png";

const AquaIndiaBanner = () => {
  return (
    <div className="w-full md:w-[90%] md:mt-[100px] mt-[0px] mx-auto bg-white overflow-hidden font-sans ">
      {/* border-[1px] rounded-lg border-gray-100 shadow-[0_0_20px_rgba(0,0,0,0.2)] */}
      {/* Header Section */}
      <div className="p-2 md:p-6 flex flex-row md:items-center items-end justify-between gap-2">
        {/* 1. Left Side: Logo + Date Group */}
        <div className="flex flex-col px-2 items-start w-[70%] md:w-auto">
          {/* Main Logo */}
          <div className="relative">
            <img
              src={AQUA_LOGO}
              className="w-[200px] md:w-[380px] object-contain"
              alt="Aqua India Logo"
            />

            {/* <div className="mt-2 border-l-0 md:border-l-2 border-gray-300 leading-relaxed pl-3 md:mt-0 text-center md:absolute md:left-36 md:bottom-[6px] md:ml-4 w-[250px] text-[10px] md:text-sm font-semibold text-gray-800 md:text-left">
              13th Edition of Biennial Marquee Event of Indian Shrimp Culture
            </div> */}
          </div>
        </div>

        {/* 2. Right Side: Icons */}
        <div className="flex items-center gap-2 mt-4 md:mt-0">
          <img
            src={LogoRound}
            alt="Temple"
            className="w-20 md:w-28 object-contain"
          />
        </div>
      </div>

      {/* --- BLUE STRIP (LOCATION) --- */}
      <div className="bg-[#007cc2] text-white text-center py-2 px-4 text-xs font-bold uppercase tracking-widest mt-2 md:mt-0">
        30 & 31 JANUARY, 2026 - Radisson Blu Resort, Temple Bay Mamallapuram,
        Tamil Nadu, India
      </div>

      {/* --- BOTTOM BODY SECTION --- */}
      <div className="relative bg-gradient-to-b from-blue-50 to-white p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          <div className="md:col-span-2 space-y-4 text-black">
            <p className="text-lg md:text-xl font-semibold leading-relaxed">
              The Society of Aquaculture Professionals is pleased to present
              <strong className="text-blue-900"> Aqua India 2026</strong>, the
              13th edition of our biennial marquee event.
            </p>
            <div className="text-sm leading-relaxed text-gray-600 space-y-3">
              <p>
                The sector continues to face shifting market signals, evolving
                trade dynamics, and ongoing production and biosecurity
                challenges.
              </p>
              <p>
                This edition calls the industry to regroup as a community,
                rethink established assumptions, and refocus on resilient,
                future-ready strategies.
              </p>
            </div>
          </div>
          <div className="md:col-span-1 flex justify-center bg-transparent">
            <div className=" w-full">
              <img
                src={Shrimp}
                alt="Shrimp"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AquaIndiaBanner;
